import { render, staticRenderFns } from "./graduationYj.vue?vue&type=template&id=02689fa2&scoped=true"
import script from "./graduationYj.vue?vue&type=script&lang=js"
export * from "./graduationYj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02689fa2",
  null
  
)

export default component.exports